var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { MENU_ITEMS, BUNDLE, MENU_OPTION_EXCEPTIONS } from '@/stores/defs';
var bundleMixin = {
    computed: __assign({}, mapGetters({
        getItem: MENU_ITEMS.GET_ITEM,
        bundleGroup: BUNDLE.GET_CURRENT_GROUP,
        itemInGroup: BUNDLE.ITEM_IN_GROUP,
        allExceptions: MENU_OPTION_EXCEPTIONS.GET_ALL,
        getBundle: BUNDLE.GET_BUNDLE,
        bundleReady: BUNDLE.ALL_REQUIREMENTS,
    })),
    methods: __assign({}, mapActions({
        setBundle: BUNDLE.SET_BUNDLE,
        setBundleGroup: BUNDLE.SET_CURRENT_GROUP,
        addItemToBundle: BUNDLE.ADD_ITEM,
        clearItemsFromBundle: BUNDLE.CLEAR_ITEMS,
    })),
};
export default bundleMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/bundleMixin.ts
// module id = Uy8i
// module chunks = 18